import { useQuery } from "@tanstack/react-query";
import { discountService } from "..";

const useGetDiscountGroups = () =>
  useQuery({
    queryKey: ["getDiscountGroups"],
    queryFn: () => discountService.getDiscountGroup(),
    select: (res) => res,
  });

export { useGetDiscountGroups };
